var map = {
	"./bj.png": "2286",
	"./fh.png": "d5b1",
	"./hx.png": "c9a8",
	"./jr.png": "b707",
	"./kb.png": "c1ce",
	"./logo.png": "cf05",
	"./sg.png": "e2fc",
	"./sh.png": "4f88",
	"./tx.png": "0ff6",
	"./wx.png": "2acb",
	"./xl.png": "1a56"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";